// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-mail-magazine-check-item[data-v-147cfe1a]{align-items:center;display:flex;font-size:1rem;margin-bottom:10px;width:100%}.c-form--checkbox--square[data-v-147cfe1a]{margin-right:.5rem;height:18px;width:18px}input[type=checkbox]:checked+.c-form--checkbox--square__checked[data-v-147cfe1a]{font-size:13px}", ""]);
// Exports
module.exports = exports;
